import React from 'react';
import {styled} from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import {Typography} from "@mui/material";
import ColorSliders from "../ColorSliders";
import InputSection from "../InputSection";
import StatsSection from "../StatsSection";
import Divider from "@mui/material/Divider";
import grey from "@mui/material/colors/grey";
import HelpMenu from "../HelpMenu";
import ImagePreviewSection from "../ImagePreviewSection";
import Box from "@mui/material/Box";
import ButtonSection from "../sidebar/ButtonSection";


export const drawerWidth = 350;


const StyledDrawer = styled(Drawer)(({theme}) => ({
    width: drawerWidth,
    display: 'block',
    backgroundColor: grey[900],
    overflowX: 'hidden',
    ['& .MuiPaper-root']: {
        width: drawerWidth,
        display: 'block',
        backgroundColor: grey[900],
        overflowX: 'hidden',
        padding: theme.spacing(0, 1.5),
    }
}));

const StyledContent = styled(Box)(({theme}) => ({
    height: '100vh',
    width: `calc(100% - ${drawerWidth}px)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: drawerWidth,
    backgroundColor: '#151515',
    flexGrow: 1,
}));

const StyledTitleBar = styled(Toolbar)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    textAlign: 'center',
}));

export default function DesktopLayout(props) {

    return (
        <>
            <StyledDrawer variant={'permanent'}>
                <StyledTitleBar>
                    <Typography variant={'h4'}>AMOLED-ify</Typography>
                    <HelpMenu/>
                </StyledTitleBar>
                <Divider/>

                <InputSection/>
                <Divider/>

                <ColorSliders/>
                <Divider/>

                <StatsSection />
                <Divider/>

                <ButtonSection />

            </StyledDrawer>

            <StyledContent>
                <ImagePreviewSection/>
            </StyledContent>
        </>
    );
}

